import React from 'react'
import { ModalContainer, ModalWrapper } from './Modal.styled'
import { AnimationModal } from 'styling/GlobalStyles'
import { createPortal } from 'react-dom'

export const Modal = ({ black, noMaxH, children, maxWidth, width, noBack, ref, height, zIndex }: IModal) => { // TODO resti black prop
  const modalContent = (
    <ModalWrapper noBack={noBack} black={black} zIndex={zIndex} >
      <AnimationModal>
        <ModalContainer ref={ref} maxWidth={maxWidth} width={width} height={height} noMaxHeight={noMaxH}>
          {children}
        </ModalContainer>
      </AnimationModal>
    </ModalWrapper>
  )
  if (typeof document === 'undefined') {
    return modalContent
  }
  return createPortal(modalContent, document.body)
}

interface IModal {
  black?: boolean
  noMaxH?: boolean
  children: React.ReactNode
  maxWidth?: boolean
  width?: string
  noBack?: boolean
  zIndex?: string
  ref?: any // TODO
  height?: string
}